<script setup lang="ts">
import { computed } from 'vue'

import { useComputedAttrs, useComputedInput, useEventsToValidate } from './helpers'
import type { TextualInputProps } from './types.ts'

const props = defineProps<TextualInputProps>()
const emit = defineEmits(['update:modelValue', 'change', 'blur', 'validate', 'invalid'])
const input = useComputedInput(props, emit)
const textInput = computed({
  get: () => (input.value as string) ?? '',
  set: (value: string) => (input.value = value),
})

const attrs = useComputedAttrs(props, 'text')
const events = useEventsToValidate(emit)
</script>

<template>
  <textarea
    v-model="textInput"
    v-autofocus="props.autofocus"
    v-bind="attrs"
    :aria-required="props.required"
    :aria-invalid="props.invalid"
    v-on="events"
    :tabindex="props.tabindex"
    :rows="props.rows ?? 4"
  />
</template>
